import { CURRENT_SEL_BALL_ID } from '../constant';

//同步action，就是指action的值为Object类型的一般对象
export const updateCurrentBallInfo = data => ({type:CURRENT_SEL_BALL_ID, data})

